import React from 'react';
import numeral from 'numeral';

import { BoxWithMargin } from 'components-core';
import DiamondIcon from '@ncl/assets/images/DiamondIcon';

import { Wrapper, Label } from './CreditsBalanceStyles';

const CreditsBalance = ({ balance }) => (
  <Wrapper href="/extrato-de-creditos" data-testid="credits-balance">
    <Label>
      <BoxWithMargin responsive={{ right: '14px' }} desktop={{ right: '14px' }}>
        <DiamondIcon />
      </BoxWithMargin>
      <p>Meus Créditos</p>
    </Label>

    <p data-testid="credits-balance-value">{numeral(balance).format()}</p>
  </Wrapper>
);

export default CreditsBalance;
